<template>
  <aside class="gfr-layout-aside">
    <slot />
  </aside>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped></style>
